// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"5c9be612","703":"dd222d96"}[chunkId] + ".chunk.js";
};